import { useRef } from 'react';
import { formatDate } from '@diezhi/momo';
import { useScroll } from '@diezhi/yesio';
import { isLatestNews } from '@@/utils';
import classNames from 'classnames';
import NavBar from '@/src/components/NavBar';
import styles from './style.module.scss';

const NewsDetail = ({ data }) => {
  const scrollDivRef = useRef();
  const { showToTop, scrollToTop } = useScroll(scrollDivRef);
  const newsContent = data.content_html || data.content_edit;

  return (
    <div className={styles.newsDetail}>
      <NavBar external selectedIndex={1} />
      <div onClick={scrollToTop} className={`${styles.toTopBtn} ${showToTop ? styles.show : ''}`} />
      <div className={styles.wrap} ref={scrollDivRef}>
        <div className={styles.newsLogo} />
        <div className={styles.titleWrap}>
          {isLatestNews(data.publish_time) && <span className={styles.latest}>[最新]</span>}
          <div className={styles.title}>{data.title}</div>
        </div>
        <div className={styles.separator} />
        <div className={styles.desc}>
          {formatDate(new Date(data.publish_time), 'YY-MM-DD').formatTime}&nbsp;&nbsp;&nbsp;
          恋与制作人制作组
        </div>
        <div
          className={classNames(styles.content, {
            [styles['xiumi-news']]: !!data.editor_type,
          })}
          dangerouslySetInnerHTML={{ __html: newsContent }}
        />
        <div className={`${styles.separator} ${styles.bottom}`} />
      </div>
    </div>
  );
};

NewsDetail.defaultProps = {
  data: {},
};

export default NewsDetail;
